import { render, staticRenderFns } from "./registration-brand-segment.filter.vue?vue&type=template&id=6656b197&scoped=true"
import script from "./registration-brand-segment.filter.vue?vue&type=script&lang=ts"
export * from "./registration-brand-segment.filter.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6656b197",
  null
  
)

export default component.exports